import { FormGroup, FormBuilder, Validators, FormArray } from '@angular/forms';
import { Component, ViewChild, Output, EventEmitter, ElementRef, Input } from '@angular/core';
import { NavController, NavParams, ModalController, ToastController, Slides, ViewController, AlertController, MenuController, App } from 'ionic-angular';
import { AngularFirestore, AngularFirestoreDocument } from 'angularfire2/firestore';
import * as $ from 'jquery';
import firebase from 'firebase/app';
import { AngularFireAuth } from 'angularfire2/auth';
import { Http, Headers, RequestOptions } from '@angular/http';
import { LoadingProvider } from '../../../../../providers/loading/loading';
import createAutoCorrectedDatePipe from 'text-mask-addons/dist/createAutoCorrectedDatePipe';
import createNumberMask from 'text-mask-addons/dist/createNumberMask';
import { ViewContactPage } from '../../../../view-contact/view-contact';
import { HomePage } from '../../../../home/home';
import { SdfFormService } from '../../../../../app/services/sdf-form-service';
import { AngularFireStorage } from 'angularfire2/storage';
import { fromEvent, from } from 'rxjs';
import { debounceTime, take } from "rxjs/operators";
import { EnvDataService } from '../../../../../app/services/env-data-service';

declare var google;
@Component({
  selector: 'adf-assets-form',
  templateUrl: 'assets.html',
  providers: [EnvDataService]
})
export class AssetsForm {
  @Input() editdata: any;
  @Output() assetsFormData_evtemit=new EventEmitter();
  @Output() check=new EventEmitter();
  callMethod() {

  }

  public numberMask = createNumberMask({
    prefix: '$ ',
    allowDecimal: true,
    decimalSymbol: ".",
    decimalLimit: 2,
    suffix: ' '
  })

  assetsForm : FormGroup;
  userRole: any;
  new_val: any;
  old_val: any;
  applicant_details: any;
  allBrokers: any;
  applicant_type: any;

  SDF_form_document_id: any;
  primary_uid: any;
  edit_contact_uid: any;
  deleted_access: any;
  public change_log_string: any;
  submitAttempt: boolean = false;
  public indexx : number;
  public allAssetss: any;
  public asset_details: any;

  public validation_messages = {
    'firstname': [
        { type: 'required', message: 'Firstname is required.' }
    ],
    'lastname': [
      { type: 'required', message: 'Lastname is required.' }
    ],
    'email': [
      { type: 'required', message: 'Email is required.' }
    ],
    'mobile_phone': [
      { type: 'required', message: 'Mobile Number is required.' },
      { type: 'minlength', message: 'Mobile Number must be at least 10 digit long.' },
      { type: 'maxlength', message: 'Mobile Number must be at least 10 digit long.' }
    ],
    'date_of_birth': [
      { type: 'required', message: 'Date of Birth is required.' }
    ],
    'secondary_firstname': [
      { type: 'required', message: 'Firstname is required.' }
    ],
    'secondary_lastname': [
      { type: 'required', message: 'Lastname is required.' }
    ],
    'secondary_email': [
      { type: 'required', message: 'Email is required.' }
    ],
    'secondary_mobile_phone': [
      { type: 'required', message: 'Mobile Number is required.' },
      { type: 'minlength', message: 'Mobile Number must be at least 10 digit long.' },
      { type: 'maxlength', message: 'Mobile Number must be at least 10 digit long.' }
    ],
    'secondary_date_of_birth': [
      { type: 'required', message: 'Date of Birth is required.' }
    ],
    'primayr_goal_intention': [
      { type: 'required', message: 'Primary goal/intention of the applicant is required.' }
    ],
    'address_type': [
      { type: 'required', message: 'Address Type is required.' }
    ],
    'address_format': [
      { type: 'required', message: 'Address format is required.' }
    ],
    'street_number': [
      { type: 'required', message: 'Street Number is required.' }
    ],
    'street_name': [
      { type: 'required', message: 'Street Name is required.' }
    ],
    'street_type': [
      { type: 'required', message: 'Street Type is required.' }
    ],
    'city': [
      { type: 'required', message: 'City is required.' }
    ],
    'state': [
      { type: 'required', message: 'State is required.' }
    ],
    'postcode': [
      { type: 'required', message: 'Postcode is required.' }
    ],
    'country': [
      { type: 'required', message: 'Country is required.' }
    ],
    'housing_situation': [
      { type: 'required', message: 'Housing situation is required.' }
    ],
    'move_in_date': [
      { type: 'required', message: 'Move in date is required.' }
    ],
    'previous_address_type': [
      { type: 'required', message: 'Address Type is required.' }
    ],
    'previous_address_format': [
      { type: 'required', message: 'Address format is required.' }
    ],
    'previous_street_number': [
      { type: 'required', message: 'Street Number is required.' }
    ],
    'previous_street_name': [
      { type: 'required', message: 'Street Name is required.' }
    ],
    'previous_street_type': [
      { type: 'required', message: 'Street Type is required.' }
    ],
    'previous_city': [
      { type: 'required', message: 'City is required.' }
    ],
    'previous_state': [
      { type: 'required', message: 'State is required.' }
    ],
    'previous_postcode': [
      { type: 'required', message: 'Postcode is required.' }
    ],
    'previous_country': [
      { type: 'required', message: 'Country is required.' }
    ],
    'previous_housing_situation': [
      { type: 'required', message: 'Housing situation is required.' }
    ],
    'previous_move_in_date': [
      { type: 'required', message: 'Move in date is required.' }
    ],
    'previous_move_out_date': [
      { type: 'required', message: 'Move out date is required.' }
    ],
    'reference_broker': [
      { type: 'required', message: 'Broker is required.' }
    ],
    'gender': [
      { type: 'required', message: 'Gender is required.' }
    ],
    'current_marital_status': [
      { type: 'required', message: 'Merital status is required.' }
    ],
    'do_you_have_children': [
      { type: 'required', message: 'Do you have children?' }
    ],
    'how_many_children': [
      { type: 'required', message: 'Enter How many dependents do you have under the age of 18?' }
    ],
    'first_child_age': [
      { type: 'required', message: 'Enter Child Age.' }
    ],
    'second_child_age': [
      { type: 'required', message: 'Enter Child Age.' }
    ],
    'third_child_age': [
      { type: 'required', message: 'Enter Child Age.' }
    ],
    'fourth_child_age': [
      { type: 'required', message: 'Enter Child Age.' }
    ],
    'fifth_child_age': [
      { type: 'required', message: 'Enter Child Age.' }
    ],
    'sixth_child_age': [
      { type: 'required', message: 'Enter Child Age.' }
    ],
    'employementType': [
      { type: 'required', message: 'Employment type required.' }
    ],
    'currentlyEmployment': [
      { type: 'required', message: 'Current employment required.' }
    ],
    'expectFindWork': [
      { type: 'required', message: 'Enter expect find work.' }
    ],
    'statusyourEmployment': [
      { type: 'required', message: 'Status your employment required.' }
    ],
    'your_occupation': [
      { type: 'required', message: 'Your occupation required.' }
    ],
    'start_date': [
      { type: 'required', message: 'When did you start in this role required.' }
    ],
    'business_name': [
      { type: 'required', message: 'Business name required.' }
    ],
    'nature_of_business': [
      { type: 'required', message: 'Nature of business required.' }
    ],
    'amount': [
      { type: 'required', message: 'This field is required.' }
    ],
    'frequency': [
      { type: 'required', message: 'This field is required.' }
    ],
    'date_commenced': [
      { type: 'required', message: 'This field is required.' }
    ],
    'percentage_asset': [
      { type: 'max', message: 'Must be less than 100.' },
      { type: 'min', message: 'Must be greater than 1.' },
      { type: 'required', message: 'This field is required.' }
    ],
    'asset_value': [
      { type: 'maxlength', message: 'Maximum length should be 30.' },
      { type: 'minlength', message: 'Must be greater than 1.' },
      { type: 'required', message: 'This field is required.' }
    ],
    'current_balance': [
      { type: 'maxlength', message: 'Maximum length should be 30.' },
      { type: 'minlength', message: 'Must be greater than 1.' },
      { type: 'required', message: 'This field is required.' }
    ],
    'limit': [
      { type: 'maxlength', message: 'Maximum length should be 30.' },
      { type: 'minlength', message: 'Must be greater than 1.' },
      { type: 'required', message: 'This field is required.' }
    ],
    'repayments': [
      { type: 'maxlength', message: 'Maximum length should be 30.' },
      { type: 'minlength', message: 'Must be greater than 1.' },
      { type: 'required', message: 'This field is required.' }
    ],
    'asset_type': [
      { type: 'required', message: 'Asset type is required.' }
    ],
    'value_basis': [
      { type: 'required', message: 'Value basis is required.' }
    ],
    'ownership_title_name': [
      { type: 'required', message: 'Ownership title name is required.' }
    ],
    'primary_percentage_asset': [
      { type: 'required', message: 'Ownership percentage is required.' }
    ],
    'secondary_percentage_asset': [
      { type: 'required', message: 'Ownership percentage is required.' }
    ],
    'notes': [
      { type: 'required', message: 'Notes is required.' }
    ],
    'gross_amount': [
      { type: 'required', message: 'Rental Income Per Week is required' }
    ],
    'creditor': [
      { type: 'required', message: 'Creditor is required.' }
    ],
    'available_redraw': [
      { type: 'required', message: 'Redraw Offset is required.' }
    ],
    'loan_type': [
      { type: 'required', message: 'Load type is required.' }
    ],
    'interest_rate': [
      { type: 'required', message: 'Interest rate is required.' },
      { type: 'min', message: 'Interest rate minimum value 1.' },
      { type: 'max', message: 'Interest rate maximum value 100.' }
    ],
    'interest_rate_term': [
      { type: 'required', message: 'Interest rate term is required.' }
    ]
  }

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    public formBuilder: FormBuilder,
    public db: AngularFirestore,
    public SdfFormService: SdfFormService,
    public alertCtrl: AlertController,
  ) {
    this.userRole = window.localStorage.getItem("userRole");
    this.applicant_details = '';
    this.getAllBrokers().subscribe((data) => {
      this.allBrokers = data;
    });
    this.applicant_type = "Primary";
    this.SDF_form_document_id = this.navParams.get("SDF_form_document_id");
    let thiss = this;
    this.change_log_string = [];
    this.allAssetss = [];
    this.asset_details = [];

    this.assetsForm=formBuilder.group({
      firstname: [''],
      lastname: [''],
      itemRowsAssets: formBuilder.array([]),
      addAnotherApplicantItem: this.formBuilder.array([])
    });


  }
  ngOnInit() {

  }


  public changeAssetType($event, type, i){


    this.new_val = $event.target.value;
    this.old_val = '';
    var property = '';
    if(type == 'asset_type'){
      if(this.allAssetss.length > i){
        this.old_val = this.allAssetss[i].asset_type;
      }else{
        this.old_val = '';
      }
      if(this.old_val == undefined){
        this.old_val = '';
      }
      property = 'Asset Type';
    }
    if(this.new_val != this.old_val){
      this.asset_details.push({'property' : property, 'old_value' : this.old_val, 'new_value' : this.new_val, 'index' : i});
    }
    this.asset_details.sort((a,b)=>a.index > b.index);
  }

  initItemRowsAssets() {
    return this.formBuilder.group({

      asset_type: ['Boat', Validators.compose([Validators.maxLength(30), Validators.required])],
      asset_value: ['', Validators.compose([Validators.maxLength(30), Validators.required])],
      value_basis: ['Applicant Estimate', Validators.compose([Validators.maxLength(30), Validators.required])],
      percentage_asset: ['', Validators.compose([Validators.required, Validators.min(0), Validators.max(100)])],
      percentage_asset_0: ['', Validators.compose([Validators.min(0), Validators.max(100)])],
      percentage_asset_1: ['', Validators.compose([Validators.min(0), Validators.max(100)])],
      percentage_asset_2: ['', Validators.compose([Validators.min(0), Validators.max(100)])],
      percentage_asset_3: ['', Validators.compose([Validators.min(0), Validators.max(100)])],
      percentage_asset_4: ['', Validators.compose([Validators.min(0), Validators.max(100)])],
      institution: ['', Validators.compose([Validators.maxLength(30)])],
      account_name: ['', Validators.compose([Validators.maxLength(200)])],
      bsb: ['', Validators.compose([Validators.maxLength(30)])],
      account_no: ['', Validators.compose([Validators.maxLength(30)])],
      type: ['', Validators.compose([Validators.maxLength(30)])],
      year: ['', Validators.compose([Validators.maxLength(30)])],
      make: ['', Validators.compose([Validators.maxLength(30)])],
      description: [''],
      ownership_form:[''],
      document_id: [''],
      deleted: [0]
    });
  }

  initItemRowsAssets2(formOj) {
    return this.formBuilder.group({

      asset_type: [formOj.asset_type, Validators.compose([Validators.maxLength(30), Validators.required])],
      asset_value: [formOj.asset_value, Validators.compose([Validators.maxLength(30), Validators.required])],
      value_basis: [formOj.value_basis, Validators.compose([Validators.maxLength(30), Validators.required])],
      percentage_asset: [formOj.percentage_asset, Validators.compose([Validators.required, Validators.min(0), Validators.max(100)])],
      percentage_asset_0: [formOj.percentage_asset_0, Validators.compose([Validators.min(0), Validators.max(100)])],
      percentage_asset_1: [formOj.percentage_asset_1, Validators.compose([Validators.min(0), Validators.max(100)])],
      percentage_asset_2: [formOj.percentage_asset_2, Validators.compose([Validators.min(0), Validators.max(100)])],
      percentage_asset_3: [formOj.percentage_asset_3, Validators.compose([Validators.min(0), Validators.max(100)])],
      percentage_asset_4: [formOj.percentage_asset_4, Validators.compose([Validators.min(0), Validators.max(100)])],
      institution: [formOj.institution, Validators.compose([Validators.maxLength(30)])],
      account_name: [formOj.account_name, Validators.compose([Validators.maxLength(200)])],
      bsb: [formOj.bsb, Validators.compose([Validators.maxLength(30)])],
      account_no: [formOj.account_no, Validators.compose([Validators.maxLength(30)])],
      type: [formOj.type, Validators.compose([Validators.maxLength(30)])],
      year: [formOj.year, Validators.compose([Validators.maxLength(30)])],
      make: [formOj.make, Validators.compose([Validators.maxLength(30)])],
      description: [formOj.description],
      ownership_form:[formOj.ownership_form],
      document_id: [formOj.document_id],
      deleted: [0]
    });
  }


  ngOnChanges() {

  }

  editgetSDFUser(SDF_form_document_id, uid) {
    if (this.userRole == "super_admin" && this.deleted_access == 1) {
      return this.db.collection<any>("users_data", ref => ref.where('created_date', '>', 0).where('SDF_form_document_id', '==', SDF_form_document_id).where('uid', '==', uid).orderBy('created_date', 'asc')).valueChanges();
    } else {
      return this.db.collection<any>("users_data", ref => ref.where('created_date', '>', 0).where('SDF_form_document_id', '==', SDF_form_document_id).where('uid', '==', uid).where('deleted', '==', 0).orderBy('created_date', 'asc')).valueChanges();
    }
  }

  getAllBrokers() {
    return this.db.collection<any>("users", ref => ref.where('roles.broker', '==', true)).valueChanges();
  }




  changeLog(event, index: any) {

  }


 get formArrAssets() {
  return this.assetsForm.get('itemRowsAssets') as FormArray;
}


  addAssets() {
    this.formArrAssets.push(this.initItemRowsAssets());
    this.indexx = this.formArrAssets.controls.length-1;
  }

  deleteRestoreDocument(index: number, document_id: any, type: any, collection: any, status: any, index1: number) {
    let alert = this.alertCtrl.create({
      title: 'Confirm '+status+' '+type,
      message: 'Are you sure you want to '+status+' this '+type+' ?',
      buttons: [
          {
              text: 'No',
              handler: () => {

              }
          },
          {
              text: 'Yes',
              handler: () => {
                if(document_id !=""){
                  let deleted = 0;
                  if(status == 'delete'){
                    deleted = 1;
                  }
                  let postData = {
                    'document_id' : document_id,
                    'collection': collection,
                    'deleted': deleted,
                    'deleted_date' : new Date().getTime()
                  }
                  this.SdfFormService.deleteDocument(postData);
                  if(status == 'delete'){

                    if(type == 'assets'){
                      this.formArrAssets.removeAt(index);
                    }
                  }
                }else{
                  if(status == 'delete'){
                    if(type == 'assets'){
                      this.formArrAssets.removeAt(index);
                    }
                  }
                }
              }
          }
      ]
    });
    alert.present();
  }

  getValue(){

    this.assetsFormData_evtemit.emit({assertformvalue:this.assetsForm.value,assertform:this.assetsForm});
  }

  setAssetform(assetformvalue) {

    if(assetformvalue) {
      this.assetsForm.controls.firstname.setValue(assetformvalue.firstname);
      this.assetsForm.controls.lastname.setValue(assetformvalue.lastname);
      assetformvalue.addAnotherApplicantItem.forEach((item,index) => {

        if(this.formApplicant.value[index]) {
          this.formApplicant.value[index].secondary_firstname = item.secondary_firstname;
          this.formApplicant.value[index].secondary_lastname = item.secondary_lastname;
          }
          else {
            this.formApplicant.push(this.initaddAnotherApplicant(item));
          }


      });

    }
  }

  populateDataForEdit(data){

    debugger;
    if(data.length > 0)
    {


      data.forEach((element,index)=>{

        let z=this.initItemRowsAssets2(element);



        (<FormArray>this.assetsForm.get('itemRowsAssets')).push(z);
      })
    }
  }

  getUserData(e) {

    debugger;
  }



  get formApplicant() {
    return this.assetsForm.get('addAnotherApplicantItem') as FormArray;
  }

  addAnotherApplicant() {
    this.indexx = this.formApplicant.length-1;
  }

  initaddAnotherApplicant(item) {
    return this.formBuilder.group({

      secondary_firstname: [item.secondary_firstname, Validators.compose([Validators.maxLength(30), Validators.required])],
      secondary_middlename: [item.secondary_middlename, Validators.compose([Validators.maxLength(30)])],
      secondary_lastname: [item.secondary_lastname, Validators.compose([Validators.maxLength(30), Validators.required])],
      secondary_email: [item.secondary_email, Validators.compose([Validators.maxLength(100), Validators.required])],
      secondary_mobile_phone: [item.secondary_mobile_phone, Validators.compose([Validators.maxLength(30), Validators.required])],
      secondary_date_of_birth: [item.secondary_date_of_birth, Validators.compose([Validators.maxLength(30), Validators.required])],
      relationship_to_primary_applicant: [item.relationship_to_primary_applicant, Validators.compose([Validators.maxLength(30), Validators.required])],
      deleted: [0],
      uid: [''],
      document_id: ['']
    });
  }
  initaddAnotherApplicant_one(item) {
    return this.formBuilder.group({

      secondary_firstname: [item.firstname, Validators.compose([Validators.maxLength(30), Validators.required])],
      secondary_middlename: [item.middlename, Validators.compose([Validators.maxLength(30)])],
      secondary_lastname: [item.lastname, Validators.compose([Validators.maxLength(30), Validators.required])],
      secondary_email: [item.email, Validators.compose([Validators.maxLength(100), Validators.required])],
      secondary_mobile_phone: [item.mobile_phone, Validators.compose([Validators.maxLength(30), Validators.required])],
      secondary_date_of_birth: [item.date_of_birth, Validators.compose([Validators.maxLength(30), Validators.required])],
      relationship_to_primary_applicant: ['', Validators.compose([Validators.maxLength(30)])],
      deleted: [0],
      uid: [''],
      document_id: ['']
    });
  }

  assetLogData1(event, type, index, index2 = 'main'){

    this.new_val = event._value;
    this.old_val = '';
    var property = '';
    if(type == 'percentage_asset'){
      if(this.allAssetss.length > index){
        this.old_val = this.allAssetss[index].percentage_asset;
      }else{
        this.old_val = '';
      }
      if(this.old_val == undefined){
        this.old_val = '';
      }
      property = 'Percentage Asset';
    }
    if(type == 'institution'){
      if(this.allAssetss.length > index){
        this.old_val = this.allAssetss[index].institution;
      }else{
        this.old_val = '';
      }
      if(this.old_val == undefined){
        this.old_val = '';
      }
      property = 'Institution';
    }
    if(type == 'account_name'){
      if(this.allAssetss.length > index){
        this.old_val = this.allAssetss[index].account_name;
      }else{
        this.old_val = '';
      }
      if(this.old_val == undefined){
        this.old_val = '';
      }
      property = 'Account Name';
    }
    if(type == 'bsb'){
      if(this.allAssetss.length > index){
        this.old_val = this.allAssetss[index].bsb;
      }else{
        this.old_val = '';
      }
      if(this.old_val == undefined){
        this.old_val = '';
      }
      property = 'BSB';
    }
    if(type == 'account_no'){
      if(this.allAssetss.length > index){
        this.old_val = this.allAssetss[index].account_no;
      }else{
        this.old_val = '';
      }
      if(this.old_val == undefined){
        this.old_val = '';
      }
      property = 'Account Number';
    }
    if(type == 'year'){
      if(this.allAssetss.length > index){
        this.old_val = this.allAssetss[index].year;
      }else{
        this.old_val = '';
      }
      if(this.old_val == undefined){
        this.old_val = '';
      }
      property = 'Year';
    }
    if(type == 'make'){
      if(this.allAssetss.length > index){
        this.old_val = this.allAssetss[index].make;
      }else{
        this.old_val = '';
      }
      if(this.old_val == undefined){
        this.old_val = '';
      }
      property = 'Make';
    }
    if(type == 'description'){
      if(this.allAssetss.length > index){
        this.old_val = this.allAssetss[index].description;
      }else{
        this.old_val = '';
      }
      if(this.old_val == undefined){
        this.old_val = '';
      }
      property = 'Description';
    }
    if(this.new_val != this.old_val){
      this.asset_details.push({'property' : property, 'old_value' : this.old_val, 'new_value' : this.new_val, 'index' : index, 'index2' : index2});
    }
    this.asset_details.sort((a,b)=>a.index > b.index);

    this.assertPercentageDivision(index);
  }

  assertPercentageDivision(i){




    if(this.assetsForm.controls['addAnotherApplicantItem']['controls'].length === 0){
      let percentage_assert:number=parseInt((<FormArray>this.assetsForm.controls.itemRowsAssets).controls[0].get('percentage_asset').value);
      if(percentage_assert <= 100)
      {

        this.check.emit({isValid:true});
        (<FormArray>this.assetsForm.controls.itemRowsAssets).controls[0].get('percentage_asset').setErrors(null);
      }else
      {

        this.check.emit({isValid:false});
        (<FormArray>this.assetsForm.controls.itemRowsAssets).controls[0].get('percentage_asset').setErrors({});
      }
    }
    else
    {

      let percentage_assert:any;
      let arr=[];
      percentage_assert=parseInt((<FormArray>this.assetsForm.controls.itemRowsAssets).controls[i].get('percentage_asset').value);

      (<FormArray>this.assetsForm.controls.addAnotherApplicantItem).controls.forEach((element,index)=>{
             let data=(<FormArray>this.assetsForm.controls.itemRowsAssets).controls[i].get('percentage_asset_'+index).value;
             if(data != "")
             {
               arr.push(parseInt(data))
             }
      })

      arr.forEach(data=>{
       percentage_assert=percentage_assert + data;
      })

      if(percentage_assert <= 100)
      {

        this.check.emit({isValid:true});
        (<FormArray>this.assetsForm.controls.itemRowsAssets).controls[i].get('percentage_asset').setErrors(null);
        (<FormArray>this.assetsForm.controls.addAnotherApplicantItem).controls.forEach((element,index)=>{
         (<FormArray>this.assetsForm.controls.itemRowsAssets).controls[i].get('percentage_asset_'+index).setErrors(null);
        })
      }
      else
      {

        this.check.emit({isValid:false});
        (<FormArray>this.assetsForm.controls.itemRowsAssets).controls[i].get('percentage_asset').setErrors({});
        (<FormArray>this.assetsForm.controls.itemRowsAssets).controls[i].get('percentage_asset').markAsUntouched();
        (<FormArray>this.assetsForm.controls.addAnotherApplicantItem).controls.forEach((element,index)=>{
         (<FormArray>this.assetsForm.controls.itemRowsAssets).controls[i].get('percentage_asset_'+index).setErrors({});
         (<FormArray>this.assetsForm.controls.itemRowsAssets).controls[i].get('percentage_asset_'+index).markAsUntouched();
        })
      }



    }

  }
  setAdditionalDetails(data){
     console.log(data);
      data.forEach((element,index) => {
          if(element.type == "additional") {
            if(this.formApplicant.value[index]) {
              this.formApplicant.value[index].secondary_firstname = element.user_data.firstname;
              this.formApplicant.value[index].secondary_lastname = element.user_data.lastname;
              }
              else {
                this.formApplicant.push(this.initaddAnotherApplicant_one(element.user_data));
              }
          }
          else {
            this.assetsForm.controls.firstname.setValue(element.user_data.firstname);
            this.assetsForm.controls.lastname.setValue(element.user_data.lastname);
          }

      });
      console.log(this.assetsForm);
    }


}




// WEBPACK FOOTER //
// ./src/pages/adf-page/component/assets-and-liablities/assets/assets.ts